<ng-container *ngIf="dispDialog; else kymw0c00content">
  <table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
    [frontDispFlag]="false">
    <tr class="subwindow-title" cdkDragHandle>
      <th class="window-title-name">画像作成指示</th>
      <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
    </tr>
    <tr class="subwindow-body">
      <td>
        <ng-container *ngIf="dispDialog; then kymw0c00content"></ng-container>
      </td>
    </tr>
    <tfoot cdkDragHandle>
      <tr>
        <td>
          <div class="footer-buttons">
            <button id="btn_New" class="btn-tartiary" [disabled]='!kymw0C00Model.btnNewEnabled'
            (click)="eventNew_ClickHandler(null)" [tabindex]="0">全項目をクリア</button>
            <button id="btn_Output" class="btn-secondary" [disabled]='!kymw0C00Model.btnOutputEnabled'
            (click)="eventOutput_ClickHandler(null)" [tabindex]="0">出力</button>
            <button id="btn_Update" class="btn-primary" [disabled]='!kymw0C00Model.btnUpdateEnabled'
            (click)="eventUpdate_ClickHandler()" [tabindex]="0">更新</button>
          </div>
          <div class="window-title-close">
            <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
            <button [tabindex]="0" (click)="onClickWindowClose()"></button>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</ng-container>

<ng-template #kymw0c00content>
  <div class="contents-area" (dragstart)="onDragstartBody($event)">
    <div>
      <h2>画像共通項目</h2>
      <div class="element-column">
        <div class="block-row">
          <div class="column-list">
            <div class="list-input-title layout_balance">
              <label>使用受注コード</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="bottom" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <app-order-code-text-input id="txti_StartOrderCode" #txti_StartOrderCode
                [subid]="'txti_StartOrderCode'" [style.width.rem]="7"
                [catalogIDField]="txti_startOrderDelivCatalogID" [tabindex]="0" [required]="true"
                [(ngModel)]="kymw0C00Model.startOrderCode" [disabled]="!kymw0C00Model.startOrderCodeEnabled"
                (ngModelChange)="eventStartOrderCode_ChangedHandler()"></app-order-code-text-input>
              <label>～</label>
              <app-order-code-text-input id="txti_EndOrderCode" #txti_EndOrderCode [subid]="'txti_EndOrderCode'"
                [catalogIDField]="txti_endOrderDelivCatalogID" [tabindex]="0"
                [required]="false" [disabled]="!kymw0C00Model.endOrderCodeEnabled"
                [(ngModel)]="kymw0C00Model.endOrderCode" (ngModelChange)="eventEndOrderCode_ChangeHandler()">
              </app-order-code-text-input>
              <app-checkbox-label id="chk_EndOrderNothing" #chk_EndOrderNothing [subid]="'chk_EndOrderNothing'"
                label="無期限" [tabindex]="0" [disabled]="!kymw0C00Model.endOrderNothingEnabled"
                [(ngModel)]="kymw0C00Model.endOrderNothing" (change)="eventEndOrderNothing_CheckHandler()">
              </app-checkbox-label>
            </div>
            <label class="list-input-title">使用配達企画回</label>
            <div class="list-input-content">
              <input type="text" class="deliv-catalog" id="txti_startOrderDelivCatalogID"
                #txti_startOrderDelivCatalogID [readonly]="true"
                plessInputTextSub [restrict]="'[ -￮]'">
              <label>～</label>
              <input type="text" class="deliv-catalog" id="txti_endOrderDelivCatalogID"
                #txti_endOrderDelivCatalogID [readonly]="true" plessInputTextSub
                [restrict]="'[ -￮]'" />
              <app-checkbox-label id="chk_EndOrderEqual" #chk_EndOrderEqual [subid]="'chk_EndOrderEqual'"
                label="今回のみ" [tabindex]="0" [(ngModel)]="kymw0C00Model.endOrderEqual"
                (change)="eventEndOrderEqual_CheckHandler()">
              </app-checkbox-label>
            </div>
            <div class="list-input-title layout_balance">
              <label>Ｐコード</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <app-text-input id="txti_PCode" #txti_PCode [subid]="'txti_PCode'" [restrict]="'[P0-9]'"
                [maxChars]="8" [tabindex]="0" [displayCountField]="false" [disabled]="!kymw0C00Model.pCodeEnabled"
                (input)="eventPCode_ChangedHandler()" [(ngModel)]="kymw0C00Model.pCode" class="pcode"></app-text-input>
            </div>
          </div>
          <div class="column-list" style="height: max-content;">
            <label class="list-input-title">所属</label>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_ImageBelongID" #cmb_ImageBelongID [subid]="'cmb_ImageBelongID'"
                [required]="true" [codeDiv]="'ct365'" [labelField]="'codeValueName'"
                initFocusItem="txti_StartOrderCode" [tabindex]="0" [disabled]="!kymw0C00Model.imageBelongIdEnabled"
                [(ngModel)]="kymw0C00Model.imageBelongID">
              </app-code-combo-box>
            </div>
            <div class="list-input-title layout_balance">
              <label>撮影予定日</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <wj-input-date class="text-label-required" id="dtf_PhotoSchedule" #dtf_PhotoSchedule format="yyyy/MM/dd"
                [isRequired]="false" [value]="null" [min]="minDate" [max]="maxDate"
                [(text)]="kymw0C00Model.photoSchedule" [tabindex]="0"></wj-input-date>
            </div>
            <div class="list-input-title layout_balance">
              <label>画像種類</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_ImageKind" [subid]="'cmb_ImageKind'" [required]="true" [codeDiv]="'ct366'"
                [labelField]="'codeValueName'" initFocusItem="txti_StartOrderCode" [tabindex]="0"
                (change)="eventImageKind_CHANGEHandler()" [(ngModel)]="kymw0C00Model.imageKind">
              </app-code-combo-box>
            </div>
          </div>
          <div class="column-list" style="height: max-content;">
            <div class="list-input-title layout_balance">
              <label>eフレンズ対象</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="bottom" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <label><input type="checkbox" id="chk_eFriends" [tabindex]="0" [(ngModel)]="kymw0C00Model.eFriends" />対象</label>
            </div>
            <div class="list-input-title layout_balance">
              <label>撮影場所</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content" style="width: 215px;">
              <app-studio-master-combo-box class="combo-box-required" [required]="true" id="cmb_PhotoStudioID"
                [subid]="'cmb_PhotoStudioID'" [tabindex]="0"
                [(ngModel)]="kymw0C00Model.photoStudioID"></app-studio-master-combo-box>
            </div>
          </div>
        </div>
        <div class="block-row">
          <div class="column-list" style="width: 695px;">
            <div class="list-input-title layout_balance">
              <label>商品案内用商品名</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <input type="text" plessInputTextSub [restrict]="'[ -￮]'"
                class="list-input-content" id="txti_GuideGoodsName" [readonly]="true"
                [(ngModel)]="kymw0C00Model.guideGoodsName" class="guide-goods-name" />
            </div>
            <div class="list-input-title layout_balance">
              <label>サンプル発注先コード</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <app-text-input id="txti_SampleOrderingCode" #txti_SampleOrderingCode
                [subid]="'txti_SampleOrderingCode'" [style.width.rem]="8" [restrict]="'[0-9]'" [maxChars]="6"
                [tabindex]="0" [displayCountField]="false" (input)="eventSampleOrderingCode_ChangedHandler()"
                [(ngModel)]="kymw0C00Model.sampleOrderingCode">
              </app-text-input>
              <button id="btn_SampleOrderingSeach" class="btn-secondary"
                (click)="eventSampleOrderingSeach_ClickHandler()" [tabindex]="0">検索</button>
              <input type="text" plessInputTextSub [restrict]="'[ -￮]'" id="txti_SampleSupplierNameKanji"
                #txti_SampleSupplierNameKanji
                [(ngModel)]="kymw0C00Model.sampleSupplierNameKanji" [readonly]="true"/>
            </div>
            <label class="list-input-title">請求先コード</label>
            <div class="list-input-content">
              <app-text-input id="txti_BillingCode" #txti_BillingCode [subid]="'txti_BillingCode'"
                [style.width.rem]="8" [restrict]="'[0-9]'" [maxChars]="6" [tabindex]="0" [displayCountField]="false"
                (input)="eventBillingCode_ChangedHandler()" [(ngModel)]="kymw0C00Model.billingCode">
              </app-text-input>
              <button id="btn_BillingSeach" class="btn-secondary" (click)="eventBillingSeach_ClickHandler()"
                [tabindex]="0">検索</button>
              <input type="text" id="txti_BillingSupplierNameKanji" #txti_BillingSupplierNameKanji
                  plessInputTextSub [restrict]="'[ -￮]'"
                [(ngModel)]="kymw0C00Model.billingSupplierNameKanji" [readonly]="true"/>
            </div>
          </div>
          <div class="column-list">
            <div class="list-input-title layout_balance">
              <label>商品案内用規格名</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <input type="text" plessInputTextSub [restrict]="'[ -￮]'"
                id="txti_GuideStandardName" [readonly]="true" 
                [(ngModel)]="kymw0C00Model.guideStandardName" class="guide-standard-name" />
            </div>
            <label class="list-input-title">請求対象</label>
            <div class="list-input-content">
              <label><input type="checkbox" id="chk_BillingTargetDiv" #chk_BillingTargetDiv [tabindex]="0"
                  [(ngModel)]="kymw0C00Model.billingTargetDiv" />対象</label>
            </div>
            <label class="list-input-title">メモ</label>
            <div class="list-input-content">
              <app-text-input id="txti_Memo" #txti_Memo [maxChars]="25" [tabindex]="0" [displayCountField]="false"
                [fullOnly]="true" [(ngModel)]="kymw0C00Model.memo" [width]="'27rem'" [restrict]="'[ -￮]'">
              </app-text-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h2>画像個別項目</h2>
      <div class="element-column">
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title" style="width: 9rem;">画像名</label>
            <div class="list-input-content">
              <input type="text" id="txti_ImageName" [readonly]="true"
                plessInputTextSub [restrict]="'[ -￮]'" [(ngModel)]="kymw0C00Model.imageName"/>
            </div>
            <div class="list-input-title layout_balance">
              <label>画像種別</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content" style="width: 140px;">
              <app-code-combo-box id="cmb_ImageType" #cmb_ImageType [subid]="'cmb_ImageType'" [required]="true"
                [codeDiv]="'ct367'" [labelField]="'codeValueName'" initFocusItem="txti_StartOrderCode" [tabindex]="0"
                (change)="eventImageType_CHANGEDHandler()" [disabled]="!kymw0C00Model.imageTypeEnabled"
                [(ngModel)]="kymw0C00Model.imageType">
              </app-code-combo-box>
            </div>
            <div class="list-input-title layout_balance">
              <label>調理指示</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content" style="width: 140px;">
              <app-code-combo-box id="cmb_ProcessInstruct" #cmb_ProcessInstruct [subid]="'cmb_ProcessInstruct'"
                [required]="true" [codeDiv]="'ct368'" initFocusItem="txti_StartOrderCode" [tabindex]="0"
                [labelField]="'codeValueName'" [disabled]="!kymw0C00Model.processInstructEnabled"
                [(ngModel)]="kymw0C00Model.processInstruct" (change)="eventProcessInstruct_CHANGEDHandler()">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">料理名</label>
            <div class="list-input-content" style="width: 25rem;">
              <app-text-input id="txti_CookingName" #txti_CookingName [maxChars]="20" [tabindex]="0"
                [displayCountField]="false" [fullOnly]="true" [restrict]="'[ -￮]'"
                [(ngModel)]="kymw0C00Model.cookingName">
              </app-text-input>
            </div>
            <label class="list-input-title">材料名</label>
            <div class="list-input-content" style="width: 25rem;">
              <app-text-input id="txti_MaterialName" #txti_MaterialName [maxChars]="20" [tabindex]="0"
                [displayCountField]="false" [fullOnly]="true" [restrict]="'[ -￮]'"
                [(ngModel)]="kymw0C00Model.materialName">
              </app-text-input>
            </div>
            <div class="list-input-title layout_balance">
              <label>料理分類</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_CookingDiv" #cmb_CookingDiv [subid]="'cmb_CookingDiv'" [codeDiv]="'ct369'"
                initFocusItem="txti_StartOrderCode" [tabindex]="0" [labelField]="'codeValueName'"
                [(ngModel)]="kymw0C00Model.cookingDiv">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">撮影内容区分</label>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_PhotoContentsDiv" #cmb_PhotoContentsDiv [subid]="'cmb_PhotoContentsDiv'"
                [codeDiv]="'ct372'" initFocusItem="txti_StartOrderCode" [tabindex]="0" [labelField]="'codeValueName'"
                [(ngModel)]="kymw0C00Model.photoContentsDiv">
              </app-code-combo-box>
            </div>
          </div>
          <div class="column-list" style="height: max-content;">
            <div class="list-input-title layout_balance" style="width: 9rem;">
              <label>画像ファイル名</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <input type="text" plessInputTextSub [restrict]="'[ -￮]'"
                id="txti_ImageFileName" [readonly]="true"
                [(ngModel)]="kymw0C00Model.imageFileName" />
            </div>
            <label class="list-input-title">ステータス</label>
            <div class="list-input-content">
              <input type="text" plessInputTextSub [restrict]="'[ -￮]'" id="txti_Status"
                [readonly]="true" [(ngModel)]="kymw0C00Model.statusName" />
            </div>
            <label class="list-input-title">調理例掲載区分</label>
            <div class="list-input-content">
              <label><input type="checkbox" id="chk_CookingExPublish" [tabindex]="0"
                  [(ngModel)]="kymw0C00Model.cookingExPublish" />掲載あり</label>
            </div>
            <div class="list-input-title layout_balance">
              <label>季節・催事</label>
              <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
                <fa-icon [icon]="iconQuestion"></fa-icon></label>
            </div>
            <div class="list-input-content">
              <app-code-combo-box id="cmb_EventID" #cmb_EventID [subid]="'cmb_EventID'" [codeDiv]="'ct370'"
                initFocusItem="txti_StartOrderCode" [tabindex]="0" [labelField]="'codeValueName'"
                [(ngModel)]="kymw0C00Model.eventID">
              </app-code-combo-box>
            </div>
            <label class="list-input-title">画像キャプション</label>
            <div class="list-input-content" style="width: 25rem;">
              <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txti_Caption" #txti_Caption
                [subid]="'txti_Caption'" [maxChars]="50" [tabindex]="0" [displayCountField]="false" [height]="72"
                [(ngModel)]="kymw0C00Model.textCaption">
              </app-text-area>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title" style="width: 7rem;">備考</label>
            <div class="list-input-content" [style.width.px]="dispDialog ? 404: 515">
              <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_Remarks" #txta_Remarks
                [subid]="'txta_Remarks'" [maxChars]="128" [tabindex]="0" [displayCountField]="false" [height]="66"
                [(ngModel)]="kymw0C00Model.remarks">
              </app-text-area>
            </div>
            <label class="list-input-title">キーワード</label>
            <div class="list-input-content">
              <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txti_KeyWord" #txti_KeyWord
                [subid]="'txti_KeyWord'" [maxChars]="128" [tabindex]="0" [displayCountField]="false" [height]="66"
                [(ngModel)]="kymw0C00Model.keyWord">
              </app-text-area>
            </div>
          </div>
        </div>
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title" style="width: 9rem;">複数コード</label>
            <div class="list-input-content">
              <app-text-input id="txti_MultipleCode" #txti_MultipleCode [maxChars]="51" [tabindex]="0"  style="width: 55rem;"
                [displayCountField]="false" [restrict]="'[ -￮]'" [(ngModel)]="kymw0C00Model.multipleCode">
              </app-text-input>
            </div>
            <label class="list-input-title">プロモーション</label>
            <div class="list-input-content">
              <label><input type="checkbox" id="chk_PromotionFlg" [tabindex]="0"
              [(ngModel)]="kymw0C00Model.promotionFlg" />プロモーションあり</label>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title" style="width: 9rem;">サンプル数量</label>
            <div class="list-input-content">
              <app-text-input id="txti_SampleNum" #txti_SampleNum [maxChars]="3" [tabindex]="0"
                [displayCountField]="false" [restrict]="'[0-9]'"
                [(ngModel)]="kymw0C00Model.sampleNum" style="width: 5rem;">
              </app-text-input>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 画像種別：包材 -->
    <div [style.display]="kymw0C00Model.imageTypeStatusVisible === 'A' ? 'block' : 'none'">
      <h3>撮影注意事項</h3>
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">撮影</label>
          <div class="list-input-content">
            <app-radio-label [label]="'ラベル面'" id="rbtn_Shooting1" #rbtn_Shooting1 [subid]="'rbtn_Shooting1'"
              [tabindex]="0" (change)="eventShooting_CHANGEHandler()" name="grp_Shooting"
              value="01" [(ngModel)]="kymw0C00Model.shooting">
            </app-radio-label>
            <app-radio-label [label]="'ラベルのない面'" id="rbtn_Shooting2" #rbtn_Shooting2 [subid]="'rbtn_Shooting2'"
              [tabindex]="0" (change)="eventShooting_CHANGEHandler()" name="grp_Shooting"
              value="02" [(ngModel)]="kymw0C00Model.shooting">
            </app-radio-label>
            <app-radio-label [label]="'外包材のみ'" id="rbtn_Shooting3" #rbtn_Shooting3 [subid]="'rbtn_Shooting3'"
              [tabindex]="0" (change)="eventShooting_CHANGEHandler()" name="grp_Shooting"
              value="03" [(ngModel)]="kymw0C00Model.shooting">
            </app-radio-label>
            <app-radio-label [label]="'個包装のみ'" id="rbtn_Shooting4" #rbtn_Shooting4 [subid]="'rbtn_Shooting4'"
              [tabindex]="0" (change)="eventShooting_CHANGEHandler()" name="grp_Shooting"
              value="04" [(ngModel)]="kymw0C00Model.shooting">
            </app-radio-label>
            <app-radio-label [label]="'外包材と個包装'" id="rbtn_Shooting5" #rbtn_Shooting5 [subid]="'rbtn_Shooting5'"
              [tabindex]="0" (change)="eventShooting_CHANGEHandler()" name="grp_Shooting"
              value="05" [(ngModel)]="kymw0C00Model.shooting">
            </app-radio-label>
            <app-text-input id="txti_ShootingPackageText" #txti_ShootingPackageText [subid]="'txti_ShootingPackageText'" 
              [maxChars]="4" [tabindex]="0" [displayCountField]="false" style="width: 5rem"
              [restrict]="'[0-9]'" [disabled]="!kymw0C00Model.shootingPackageTextEnabled" [(ngModel)]="kymw0C00Model.shootingPackageText">
            </app-text-input>
          <label>P</label>
          </div>
          <label class="list-input-title">撮影角度</label>
          <div class="list-input-content">
            <app-radio-label [label]="'正面'" id="rbtn_ShootingAngle1" #rbtn_ShootingAngle1 [subid]="'rbtn_ShootingAngle1'"
              [tabindex]="0" name="grp_ShootingAngle"
              value="01" [(ngModel)]="kymw0C00Model.shootingAngle">
            </app-radio-label>
            <app-radio-label [label]="'二面'" id="rbtn_ShootingAngle2" #rbtn_ShootingAngle2 [subid]="'rbtn_ShootingAngle2'"
              [tabindex]="0" name="grp_ShootingAngle"
              value="02" [(ngModel)]="kymw0C00Model.shootingAngle">
            </app-radio-label>
            <app-radio-label [label]="'三面'" id="rbtn_ShootingAngle3" #rbtn_ShootingAngle3 [subid]="'rbtn_ShootingAngle3'"
              [tabindex]="0" name="grp_ShootingAngle"
              value="03" [(ngModel)]="kymw0C00Model.shootingAngle">
            </app-radio-label>
          </div>
          <label class="list-input-title">並べ方</label>
          <div class="list-input-content">
            <app-radio-label [label]="'左手前に重ねる（横'" id="rbtn_Alignment1" #rbtn_Alignment1 [subid]="'rbtn_Alignment1'"
              [tabindex]="0" name="grp_Alignment" (change)="eventAlignment_CHANGEHandler()"
              value="01" [(ngModel)]="kymw0C00Model.alignment">
            </app-radio-label>
            <app-text-input id="txti_AlignmentHorizontal" #txti_AlignmentHorizontal [subid]="'txti_AlignmentHorizontal'" 
              [maxChars]="4" [tabindex]="0" [displayCountField]="false" style="width: 5rem;"
              [restrict]="'[0-9]'" [disabled]="!kymw0C00Model.alignmentHorizontalEnabled" [(ngModel)]="kymw0C00Model.alignmentHorizontal">
            </app-text-input>
            <label>×</label>
            <label>縦</label>
            <app-text-input id="txti_AlignmentVertical" #txti_AlignmentVertical [subid]="'txti_AlignmentVertical'" 
              [maxChars]="4" [tabindex]="0" [displayCountField]="false" style="width: 5rem;"
              [restrict]="'[0-9]'" [disabled]="!kymw0C00Model.alignmentVerticalEnabled" [(ngModel)]="kymw0C00Model.alignmentVertical">
            </app-text-input>
            <label>）</label>
            <app-radio-label [label]="'横並'" id="rbtn_Alignment2" #rbtn_Alignment2 [subid]="'rbtn_Alignment2'"
              [tabindex]="0" (change)="eventAlignment_CHANGEHandler()" name="grp_Alignment"
              value="02" [(ngModel)]="kymw0C00Model.alignment">
            </app-radio-label>
            <app-radio-label [label]="'扇型'" id="rbtn_Alignment3" #rbtn_Alignment3 [subid]="'rbtn_Alignment3'"
              [tabindex]="0" (change)="eventAlignment_CHANGEHandler()" name="grp_Alignment"
              value="03" [(ngModel)]="kymw0C00Model.alignment">
            </app-radio-label>
            <app-radio-label [label]="'横二列'" id="rbtn_Alignment4" #rbtn_Alignment4 [subid]="'rbtn_Alignment4'"
              [tabindex]="0" (change)="eventAlignment_CHANGEHandler()" name="grp_Alignment"
              value="04" [(ngModel)]="kymw0C00Model.alignment">
            </app-radio-label>
            <app-radio-label [label]="'前1後2'" id="rbtn_Alignment5" #rbtn_Alignment5 [subid]="'rbtn_Alignment5'"
              [tabindex]="0" (change)="eventAlignment_CHANGEHandler()" name="grp_Alignment"
              value="05" [(ngModel)]="kymw0C00Model.alignment">
            </app-radio-label>
            <app-radio-label [label]="'積み上げ'" id="rbtn_Alignment6" #rbtn_Alignment6 [subid]="'rbtn_Alignment6'"
              [tabindex]="0" (change)="eventAlignment_CHANGEHandler()" name="grp_Alignment"
              value="06" [(ngModel)]="kymw0C00Model.alignment">
            </app-radio-label>
          </div>
          <div class="list-input-title layout_balance">
            <label>撮影指示内容</label>
            <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
              <fa-icon [icon]="iconQuestion"></fa-icon></label>
          </div>
          <div class="list-input-content">
            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_PhotoInstructContents1"
              #txta_PhotoInstructContents1 [subid]="'txta_PhotoInstructContents1'" [maxChars]="256" [tabindex]="0"
              [displayCountField]="true" [height]="92" [(ngModel)]="kymw0C00Model.photoInstructContents"
              [style.width.px]="980">
            </app-text-area>
          </div>
        </div>
      </div>
    </div>

    <!-- 画像種別：皿盛・ザル盛 -->
    <div [style.display]="kymw0C00Model.imageTypeStatusVisible === 'B' ? 'block' : 'none'">
      <h3>撮影注意事項</h3>
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">器</label>
          <div class="list-input-content">
            <app-radio-label [label]="'丸皿'" id="rbtn_VesselPlating1" #rbtn_VesselPlating1 [subid]="'rbtn_VesselPlating1'"
              [tabindex]="0" name="grp_VesselPlating"
              value="01" [(ngModel)]="kymw0C00Model.vesselPlating">
            </app-radio-label>
            <app-radio-label [label]="'角皿'" id="rbtn_VesselPlating2" #rbtn_VesselPlating2 [subid]="'rbtn_VesselPlating2'"
              [tabindex]="0" name="grp_VesselPlating"
              value="02" [(ngModel)]="kymw0C00Model.vesselPlating">
            </app-radio-label>
            <app-radio-label [label]="'丸ザル'" id="rbtn_VesselPlating3" #rbtn_VesselPlating3 [subid]="'rbtn_VesselPlating3'"
              [tabindex]="0" name="grp_VesselPlating"
              value="03" [(ngModel)]="kymw0C00Model.vesselPlating">
            </app-radio-label>
            <app-radio-label [label]="'角ザル'" id="rbtn_VesselPlating4" #rbtn_VesselPlating4 [subid]="'rbtn_VesselPlating4'"
              [tabindex]="0" name="grp_VesselPlating"
              value="04" [(ngModel)]="kymw0C00Model.vesselPlating">
            </app-radio-label>
            <app-radio-label [label]="'ゲタ'" id="rbtn_VesselPlating5" #rbtn_VesselPlating5 [subid]="'rbtn_VesselPlating5'"
              [tabindex]="0" name="grp_VesselPlating"
              value="05" [(ngModel)]="kymw0C00Model.vesselPlating">
            </app-radio-label>
            <app-radio-label [label]="'塗り物'" id="rbtn_VesselPlating6" #rbtn_VesselPlating6 [subid]="'rbtn_VesselPlating6'"
              [tabindex]="0" name="grp_VesselPlating"
              value="06" [(ngModel)]="kymw0C00Model.vesselPlating">
            </app-radio-label>
          </div>
          <label class="list-input-title">皿の色変更（基本はグリーン）</label>
          <div class="list-input-content">
            <app-code-combo-box id="cmb_ColorChange" #cmb_ColorChange [subid]="'cmb_ColorChange'" [codeDiv]="'ctp230'"
              [tabindex]="0" [labelField]="'codeValueName'"
              [(ngModel)]="kymw0C00Model.colorChange" style="width: 5rem;">
            </app-code-combo-box>
          </div>
          <label class="list-input-title">盛り方</label>
          <div class="list-input-content">
            <app-radio-label [label]="'山高盛り'" id="rbtn_Plating1" #rbtn_Plating1 [subid]="'rbtn_Plating1'"
              [tabindex]="0" name="grp_Plating"
              value="01" [(ngModel)]="kymw0C00Model.plating">
            </app-radio-label>
            <app-radio-label [label]="'個包装のまま'" id="rbtn_Plating2" #rbtn_Plating2 [subid]="'rbtn_Plating2'"
              [tabindex]="0" name="grp_Plating"
              value="02" [(ngModel)]="kymw0C00Model.plating">
            </app-radio-label>
            <app-radio-label [label]="'平らに並べる'" id="rbtn_Plating3" #rbtn_Plating3 [subid]="'rbtn_Plating3'"
              [tabindex]="0" name="grp_Plating"
              value="03" [(ngModel)]="kymw0C00Model.plating">
            </app-radio-label>
          </div>
          <label class="list-input-title">添え物</label>
          <div class="list-input-content">
            <app-radio-label [label]="'葉野菜'" id="rbtn_Accompaniments1" #rbtn_Accompaniments1 [subid]="'rbtn_Accompaniments1'"
              [tabindex]="0" name="grp_Accompaniments"
              value="01" [(ngModel)]="kymw0C00Model.accompaniments">
            </app-radio-label>
            <app-radio-label [label]="'笹'" id="rbtn_Accompaniments2" #rbtn_Accompaniments2 [subid]="'rbtn_Accompaniments2'"
              [tabindex]="0" name="grp_Accompaniments"
              value="02" [(ngModel)]="kymw0C00Model.accompaniments">
            </app-radio-label>
            <app-radio-label [label]="'大葉'" id="rbtn_Accompaniments3" #rbtn_Accompaniments3 [subid]="'rbtn_Accompaniments3'"
              [tabindex]="0" name="grp_Accompaniments"
              value="03" [(ngModel)]="kymw0C00Model.accompaniments">
            </app-radio-label>
            <app-radio-label [label]="'青み添え'" id="rbtn_Accompaniments4" #rbtn_Accompaniments4 [subid]="'rbtn_Accompaniments4'"
              [tabindex]="0" name="grp_Accompaniments"
              value="04" [(ngModel)]="kymw0C00Model.accompaniments">
            </app-radio-label>
            <app-radio-label [label]="'白紙'" id="rbtn_Accompaniments5" #rbtn_Accompaniments5 [subid]="'rbtn_Accompaniments5'"
              [tabindex]="0" name="grp_Accompaniments"
              value="05" [(ngModel)]="kymw0C00Model.accompaniments">
            </app-radio-label>
            <app-radio-label [label]="'和紙'" id="rbtn_Accompaniments6" #rbtn_Accompaniments6 [subid]="'rbtn_Accompaniments6'"
              [tabindex]="0" name="grp_Accompaniments"
              value="06" [(ngModel)]="kymw0C00Model.accompaniments">
            </app-radio-label>
          </div>
          <div class="list-input-title layout_balance">
            <label>撮影指示内容</label>
            <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
              <fa-icon [icon]="iconQuestion"></fa-icon></label>
          </div>
          <div class="list-input-content">
            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_PhotoInstructContents2"
              #txta_PhotoInstructContents2 [subid]="'txta_PhotoInstructContents2'" [maxChars]="256" [tabindex]="0"
              [displayCountField]="true" [height]="92" [(ngModel)]="kymw0C00Model.photoInstructContents"
              [style.width.px]="980">
            </app-text-area>
          </div>
        </div>
      </div>
    </div>


    <!-- 画像種別：調理イメージ(調理要)-->
    <div [style.display]="kymw0C00Model.imageTypeStatusVisible === 'C1' ? 'block' : 'none'">
      <h3>撮影注意事項</h3>
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">数量</label>
          <div class="list-input-content">
            <app-radio-label [label]="'全量'" id="rbtn_QtyCookNecessary1" #rbtn_QtyCookNecessary1 [subid]="'rbtn_QtyCookNecessary1'"
              [tabindex]="0" (change)="eventQtyCookNecessary_CHANGEHandler()" name="grp_QtyCookNecessary"
              value="01" [(ngModel)]="kymw0C00Model.qtyCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'適量'" id="rbtn_QtyCookNecessary2" #rbtn_QtyCookNecessary2 [subid]="'rbtn_QtyCookNecessary2'"
              [tabindex]="0" (change)="eventQtyCookNecessary_CHANGEHandler()" name="grp_QtyCookNecessary"
              value="02" [(ngModel)]="kymw0C00Model.qtyCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="''" id="rbtn_QtyCookNecessary3" #rbtn_QtyCookNecessary3 [subid]="'rbtn_QtyCookNecessary3'"
              [tabindex]="0" (change)="eventQtyCookNecessary_CHANGEHandler()" name="grp_QtyCookNecessary"
              value="03" [(ngModel)]="kymw0C00Model.qtyCookNecessary">
            </app-radio-label>
            <app-text-input id="txti_QtyCookNecessaryNum" #txti_QtyCookNecessaryNum [subid]="'txti_QtyCookNecessaryNum'" 
              [maxChars]="3" [tabindex]="0" [displayCountField]="false" style="width: 5rem;"
              [restrict]="'[0-9]'" [disabled]="!kymw0C00Model.qtyCookNecessaryNumEnabled" [(ngModel)]="kymw0C00Model.qtyCookNecessaryNum">
            </app-text-input>
            <label>個</label>
            <app-radio-label [label]="'1人分'" id="rbtn_QtyCookNecessary4" #rbtn_QtyCookNecessary3 [subid]="'rbtn_QtyCookNecessary3'"
              [tabindex]="0" (change)="eventQtyCookNecessary_CHANGEHandler()" name="grp_QtyCookNecessary"
              value="04" [(ngModel)]="kymw0C00Model.qtyCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'器数1'" id="rbtn_QtyCookNecessary5" #rbtn_QtyCookNecessary5 [subid]="'rbtn_QtyCookNecessary5'"
              [tabindex]="0" (change)="eventQtyCookNecessary_CHANGEHandler()" name="grp_QtyCookNecessary"
              value="05" [(ngModel)]="kymw0C00Model.qtyCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'器数2'" id="rbtn_QtyCookNecessary6" #rbtn_QtyCookNecessary6 [subid]="'rbtn_QtyCookNecessary6'"
              [tabindex]="0" (change)="eventQtyCookNecessary_CHANGEHandler()" name="grp_QtyCookNecessary"
              value="06" [(ngModel)]="kymw0C00Model.qtyCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'器数3'" id="rbtn_QtyCookNecessary7" #rbtn_QtyCookNecessary7 [subid]="'rbtn_QtyCookNecessary7'"
              [tabindex]="0" (change)="eventQtyCookNecessary_CHANGEHandler()" name="grp_QtyCookNecessary"
              value="07" [(ngModel)]="kymw0C00Model.qtyCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'器数'" id="rbtn_QtyCookNecessary8" #rbtn_QtyCookNecessary8 [subid]="'rbtn_QtyCookNecessary8'"
              [tabindex]="0" (change)="eventQtyCookNecessary_CHANGEHandler()" name="grp_QtyCookNecessary"
              value="08" [(ngModel)]="kymw0C00Model.qtyCookNecessary">
            </app-radio-label>
            <app-text-input id="txti_QtyCookNecessaryVesselNum" #txti_QtyCookNecessaryVesselNum [subid]="'txti_QtyCookNecessaryVesselNum'" 
              [maxChars]="3" [tabindex]="0" [displayCountField]="false" style="width: 5rem;"[restrict]="'[0-9]'" 
              [disabled]="!kymw0C00Model.qtyCookNecessaryVesselNumEnabled"[(ngModel)]="kymw0C00Model.qtyCookNecessaryVesselNum">
            </app-text-input>
          </div>
          <label class="list-input-title">器形状</label>
          <div class="list-input-content">
            <app-radio-label [label]="'皿'" id="rbtn_VesselShapeCookNecessary1" #rbtn_VesselShapeCookNecessary1 
              [subid]="'rbtn_VesselShapeCookNecessary1'"  [tabindex]="0"
              name="grp_VesselShapeCookNecessary" value="01" [(ngModel)]="kymw0C00Model.vesselShapeCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'鉢(深皿)'" id="rbtn_VesselShapeCookNecessary2" #rbtn_VesselShapeCookNecessary2
              [subid]="'rbtn_VesselShapeCookNecessary2'"  [tabindex]="0"
              name="grp_VesselShapeCookNecessary" value="02" [(ngModel)]="kymw0C00Model.vesselShapeCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'丸'" id="rbtn_VesselShapeCookNecessary3" #rbtn_VesselShapeCookNecessary3
              [subid]="'rbtn_VesselShapeCookNecessary3'"  [tabindex]="0"
              groupName="grp_VesselShapeCookNecessary" value="03" [(ngModel)]="kymw0C00Model.vesselShapeCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'四角'" id="rbtn_VesselShapeCookNecessary4" #rbtn_VesselShapeCookNecessary4
              [subid]="'rbtn_VesselShapeCookNecessary4'"  [tabindex]="0"
              groupName="grp_VesselShapeCookNecessary" value="04" [(ngModel)]="kymw0C00Model.vesselShapeCookNecessary">
            </app-radio-label>
          </div>
          <label class="list-input-title">器</label>
          <div class="list-input-content">
            <app-radio-label [label]="'ガラス'" id="rbtn_VesselCookNecessary1" #rbtn_VesselCookNecessary1
              [subid]="'rbtn_VesselCookNecessary1'"  [tabindex]="0"
              name="grp_VesselCookNecessary" value="01" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'洋'" id="rbtn_VesselCookNecessary2" #rbtn_VesselCookNecessary2
              [subid]="'rbtn_VesselCookNecessary2'"  [tabindex]="0" 
              name="grp_VesselCookNecessary" value="02" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'和'" id="rbtn_VesselCookNecessary3" #rbtn_VesselCookNecessary3
              [subid]="'rbtn_VesselCookNecessary3'"  [tabindex]="0"
              name="grp_VesselCookNecessary" value="03" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'土鍋'" id="rbtn_VesselCookNecessary4" #rbtn_VesselCookNecessary4
              [subid]="'rbtn_VesselCookNecessary4'"  [tabindex]="0"
              name="grp_VesselCookNecessary" value="04" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'鉄鍋'" id="rbtn_VesselCookNecessary5" #rbtn_VesselCookNecessary5
              [subid]="'rbtn_VesselCookNecessary5'"  [tabindex]="0"
              name="grp_VesselCookNecessary" value="05" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'ウッド'" id="rbtn_VesselCookNecessary6" #rbtn_VesselCookNecessary6
              [subid]="'rbtn_VesselCookNecessary6'"  [tabindex]="0"
              name="grp_VesselCookNecessary" value="06" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'丼'" id="rbtn_VesselCookNecessary7" #rbtn_VesselCookNecessary7
              [subid]="'rbtn_VesselCookNecessary7'"  [tabindex]="0"
              name="grp_VesselCookNecessary" value="07" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'スープカップ'" id="rbtn_VesselCookNecessary8" #rbtn_VesselCookNecessary8
              [subid]="'rbtn_VesselCookNecessary8'"  [tabindex]="0" 
              name="grp_VesselCookNecessary" value="08" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'グラタン皿'" id="rbtn_VesselCookNecessary9" #rbtn_VesselCookNecessary9
              [subid]="'rbtn_VesselCookNecessary9'"  [tabindex]="0" 
              name="grp_VesselCookNecessary" value="09" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'セイロ'" id="rbtn_VesselCookNecessary10" #rbtn_VesselCookNecessary10
              [subid]="'rbtn_VesselCookNecessary10'"  [tabindex]="0"
              name="grp_VesselCookNecessary" value="10" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'塗り物'" id="rbtn_VesselCookNecessary11" #rbtn_VesselCookNecessary11
              [subid]="'rbtn_VesselCookNecessary11'"  [tabindex]="0"
              name="grp_VesselCookNecessary" value="11" [(ngModel)]="kymw0C00Model.vesselCookNecessary">
            </app-radio-label>
          </div>
          <label class="list-input-title">イメージ</label>
          <div class="list-input-content">
            <app-radio-label [label]="'洋'" id="rbtn_PhotoImageCookNecessary1" #rbtn_PhotoImageCookNecessary1
              [subid]="'rbtn_PhotoImageCookNecessary1'"  [tabindex]="0"
              name="grp_PhotoImageCookNecessary" value="01" [(ngModel)]="kymw0C00Model.photoImageCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'和'" id="rbtn_PhotoImageCookNecessary2" #rbtn_PhotoImageCookNecessary2
              [subid]="'rbtn_PhotoImageCookNecessary2'"  [tabindex]="0"
              name="grp_PhotoImageCookNecessary" value="02" [(ngModel)]="kymw0C00Model.photoImageCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'中華'" id="rbtn_PhotoImageCookNecessary3" #rbtn_PhotoImageCookNecessary3
              [subid]="'rbtn_PhotoImageCookNecessary3'"  [tabindex]="0"
              name="grp_PhotoImageCookNecessary" value="03" [(ngModel)]="kymw0C00Model.photoImageCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'朝食'" id="rbtn_PhotoImageCookNecessary4" #rbtn_PhotoImageCookNecessary4
              [subid]="'rbtn_PhotoImageCookNecessary4'"  [tabindex]="0"
              name="grp_PhotoImageCookNecessary" value="04" [(ngModel)]="kymw0C00Model.photoImageCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'ランチ'" id="rbtn_PhotoImageCookNecessary5" #rbtn_PhotoImageCookNecessary5
              [subid]="'rbtn_PhotoImageCookNecessary5'"  [tabindex]="0" 
              name="grp_PhotoImageCookNecessary" value="05" [(ngModel)]="kymw0C00Model.photoImageCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'夕食'" id="rbtn_PhotoImageCookNecessary6" #rbtn_PhotoImageCookNecessary6
              [subid]="'rbtn_PhotoImageCookNecessary6'"  [tabindex]="0"
              name="grp_PhotoImageCookNecessary" value="06" [(ngModel)]="kymw0C00Model.photoImageCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'弁当'" id="rbtn_PhotoImageCookNecessary7" #rbtn_PhotoImageCookNecessary7
              [subid]="'rbtn_PhotoImageCookNecessary7'"  [tabindex]="0"
              name="grp_PhotoImageCookNecessary" value="07" [(ngModel)]="kymw0C00Model.photoImageCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'おつまみ'" id="rbtn_PhotoImageCookNecessary8" #rbtn_PhotoImageCookNecessary8
              [subid]="'rbtn_PhotoImageCookNecessary8'"  [tabindex]="0"
              name="grp_PhotoImageCookNecessary" value="08" [(ngModel)]="kymw0C00Model.photoImageCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'温かみ'" id="rbtn_PhotoImageCookNecessary9" #rbtn_PhotoImageCookNecessary9
              [subid]="'rbtn_PhotoImageCookNecessary9'"  [tabindex]="0" 
              name="grp_PhotoImageCookNecessary" value="09" [(ngModel)]="kymw0C00Model.photoImageCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'涼しさ'" id="rbtn_PhotoImageCookNecessary10" #rbtn_PhotoImageCookNecessary10
              [subid]="'rbtn_PhotoImageCookNecessary10'"  [tabindex]="0" 
              name="grp_PhotoImageCookNecessary" value="10" [(ngModel)]="kymw0C00Model.photoImageCookNecessary">
            </app-radio-label>
          </div>
          <label class="list-input-title">断面</label>
          <div class="list-input-content">
            <app-checkbox-label id="chk_CrossSection1" #chk_CrossSection1 [subid]="'chk_CrossSection1'"
              [label]="'1個カットして中見せ'" [tabindex]="0" value="01" [(ngModel)]="kymw0C00Model.crossSection">
            </app-checkbox-label>
          </div>
          <label class="list-input-title">撮影演出</label>
          <div class="list-input-content">
            <app-radio-label [label]="'箸で持つ'" id="rbtn_PhotoRenditionCookNecessary1" #rbtn_PhotoRenditionCookNecessary1
              [subid]="'rbtn_PhotoRenditionCookNecessary1'"  [tabindex]="0"
              name="grp_PhotoRenditionCookNecessary" value="01" [(ngModel)]="kymw0C00Model.photoRenditionCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'スプーンですくう'" id="rbtn_PhotoRenditionCookNecessary2" #rbtn_PhotoRenditionCookNecessary2
              [subid]="'rbtn_PhotoRenditionCookNecessary2'"  [tabindex]="0"
              name="grp_PhotoRenditionCookNecessary" value="02" [(ngModel)]="kymw0C00Model.photoRenditionCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'注ぎ入れる'" id="rbtn_PhotoRenditionCookNecessary3" #rbtn_PhotoRenditionCookNecessary3
              [subid]="'rbtn_PhotoRenditionCookNecessary3'"  [tabindex]="0"
              name="grp_PhotoRenditionCookNecessary" value="03" [(ngModel)]="kymw0C00Model.photoRenditionCookNecessary">
            </app-radio-label>
            <app-radio-label [label]="'湯気出し'" id="rbtn_PhotoRenditionCookNecessary4" #rbtn_PhotoRenditionCookNecessary4
              [subid]="'rbtn_PhotoRenditionCookNecessary4'"  [tabindex]="0"
              name="grp_PhotoRenditionCookNecessary" value="04" [(ngModel)]="kymw0C00Model.photoRenditionCookNecessary">
            </app-radio-label>
          </div>
          <div class="list-input-title layout_balance">
            <label>撮影指示内容</label>
            <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
              <fa-icon [icon]="iconQuestion"></fa-icon></label>
          </div>
          <div class="list-input-content">
            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_PhotoInstructContents3"
              #txta_PhotoInstructContents3 [subid]="'txta_PhotoInstructContents3'" [maxChars]="256" [tabindex]="0"
              [displayCountField]="true" [height]="92" [(ngModel)]="kymw0C00Model.photoInstructContents"
              [style.width.px]="980">
            </app-text-area>
          </div>
        </div>
      </div>
    </div>


    <!-- 画像種別：調理イメージ(調理不要) -->
    <div [style.display]="kymw0C00Model.imageTypeStatusVisible === 'C2' ? 'block' : 'none'">
      <h3>撮影注意事項</h3>
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">数量</label>
          <div class="list-input-content">
            <app-radio-label [label]="'全量'" id="rbtn_QtyCookUnnecessary1" #rbtn_QtyCookUnnecessary1 [subid]="'rbtn_QtyCookUnnecessary1'"
              [tabindex]="0" (change)="eventQtyCookUnnecessary_CHANGEHandler()" name="grp_QtyCookUnnecessary"
              value="1" [(ngModel)]="kymw0C00Model.qtyCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'適量'" id="rbtn_QtyCookUnnecessary2" #rbtn_QtyCookUnnecessary2 [subid]="'rbtn_QtyCookUnnecessary2'"
              [tabindex]="0" (change)="eventQtyCookUnnecessary_CHANGEHandler()" name="grp_QtyCookUnnecessary"
              value="2" [(ngModel)]="kymw0C00Model.qtyCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="''" id="rbtn_QtyCookUnnecessary3" #rbtn_QtyCookUnnecessary3 [subid]="'rbtn_QtyCookUnnecessary3'"
              [tabindex]="0" (change)="eventQtyCookUnnecessary_CHANGEHandler()" name="grp_QtyCookUnnecessary"
              value="3" [(ngModel)]="kymw0C00Model.qtyCookUnnecessary">
            </app-radio-label>
            <app-text-input id="txti_QtyCookUnnecessaryNum" #txti_QtyCookUnnecessaryNum [subid]="'txti_QtyCookUnnecessaryNum'" 
              [maxChars]="3" [tabindex]="0" [displayCountField]="false" style="width: 5rem;"
              [restrict]="'[0-9]'" [disabled]="!kymw0C00Model.qtyCookUnnecessaryNumEnabled" [(ngModel)]="kymw0C00Model.qtyCookUnnecessaryNum">
            </app-text-input>
            <label>個</label>
              <app-radio-label [label]="'器数1'" id="rbtn_QtyCookUnnecessary4" #rbtn_QtyCookUnnecessary4 [subid]="'rbtn_QtyCookUnnecessary4'"
              [tabindex]="0" (change)="eventQtyCookUnnecessary_CHANGEHandler()" name="grp_QtyCookUnnecessary"
              value="4" [(ngModel)]="kymw0C00Model.qtyCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'器数2'" id="rbtn_QtyCookUnnecessary5" #rbtn_QtyCookUnnecessary5 [subid]="'rbtn_QtyCookUnnecessary5'"
              [tabindex]="0" (change)="eventQtyCookUnnecessary_CHANGEHandler()" name="grp_QtyCookUnnecessary"
              value="5" [(ngModel)]="kymw0C00Model.qtyCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'器数3'" id="rbtn_QtyCookUnnecessary6" #rbtn_QtyCookUnnecessary6 [subid]="'rbtn_QtyCookUnnecessary6'"
              [tabindex]="0" (change)="eventQtyCookUnnecessary_CHANGEHandler()" name="grp_QtyCookUnnecessary"
              value="6" [(ngModel)]="kymw0C00Model.qtyCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'器数'" id="rbtn_QtyCookUnnecessary7" #rbtn_QtyCookUnnecessary7 [subid]="'rbtn_QtyCookUnnecessary7'"
              [tabindex]="0" (change)="eventQtyCookUnnecessary_CHANGEHandler()" name="grp_QtyCookUnnecessary"
              value="7" [(ngModel)]="kymw0C00Model.qtyCookUnnecessary">
            </app-radio-label>
            <app-text-input id="txti_QtyCookUnnecessaryVesselNum" #txti_QtyCookUnnecessaryVesselNum 
              [subid]="'txti_QtyCookUnnecessaryVesselNum'" [maxChars]="3" [tabindex]="0"
              [displayCountField]="false" style="width: 5rem;" [restrict]="'[0-9]'" 
              [disabled]="!kymw0C00Model.qtyCookUnnecessaryVesselNumEnabled"[(ngModel)]="kymw0C00Model.qtyCookUnnecessaryVesselNum">
            </app-text-input>
          </div>
          <label class="list-input-title">器形状</label>
          <div class="list-input-content">
            <app-radio-label [label]="'皿'" id="rbtn_VesselShapeCookUnnecessary1" #rbtn_VesselShapeCookUnnecessary1 
              [subid]="'rbtn_VesselShapeCookUnnecessary1'"  [tabindex]="0" 
              game="grp_VesselShapeCookUnnecessary" value="01" [(ngModel)]="kymw0C00Model.vesselShapeCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'鉢(深皿)'" id="rbtn_VesselShapeCookUnnecessary2" #rbtn_VesselShapeCookUnnecessary2
              [subid]="'rbtn_VesselShapeCookUnnecessary2'"  [tabindex]="0"
              name="grp_VesselShapeCookUnnecessary" value="02" [(ngModel)]="kymw0C00Model.vesselShapeCookUnnecessary">
            </app-radio-label>
          </div>
          <label class="list-input-title">器</label>
          <div class="list-input-content">
            <app-radio-label [label]="'ガラス'" id="rbtn_VesselCookUnnecessary1" #rbtn_VesselCookUnnecessary1
              [subid]="'rbtn_VesselCookUnnecessary1'"  [tabindex]="0"
              name="grp_VesselCookUnnecessary" value="01" [(ngModel)]="kymw0C00Model.vesselCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'洋'" id="rbtn_VesselCookUnnecessary2" #rbtn_VesselCookUnnecessary2
              [subid]="'rbtn_VesselCookUnnecessary2'"  [tabindex]="0"
              name="grp_VesselCookUnnecessary" value="02" [(ngModel)]="kymw0C00Model.vesselCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'和'" id="rbtn_VesselCookUnnecessary3" #rbtn_VesselCookUnnecessary3
              [subid]="'rbtn_VesselCookUnnecessary3'"  [tabindex]="0"
              name="grp_VesselCookUnnecessary" value="03" [(ngModel)]="kymw0C00Model.vesselCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'ウッド'" id="rbtn_VesselCookUnnecessary4" #rbtn_VesselCookUnnecessary4
              [subid]="'rbtn_VesselCookUnnecessary4'"  [tabindex]="0"
              name="grp_VesselCookUnnecessary" value="04" [(ngModel)]="kymw0C00Model.vesselCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'煎茶椀'" id="rbtn_VesselCookUnnecessary5" #rbtn_VesselCookUnnecessary5
              [subid]="'rbtn_VesselCookUnnecessary5'"  [tabindex]="0"
              name="grp_VesselCookUnnecessary" value="05" [(ngModel)]="kymw0C00Model.vesselCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'グラス'" id="rbtn_VesselCookUnnecessary6" #rbtn_VesselCookUnnecessary6
              [subid]="'rbtn_VesselCookUnnecessary6'"  [tabindex]="0"
              name="grp_VesselCookUnnecessary" value="06" [(ngModel)]="kymw0C00Model.vesselCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'コーヒーカップ'" id="rbtn_VesselCookUnnecessary7" #rbtn_VesselCookUnnecessary7
              [subid]="'rbtn_VesselCookUnnecessary7'"  [tabindex]="0"
              name="grp_VesselCookUnnecessary" value="07" [(ngModel)]="kymw0C00Model.vesselCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'ティーカップ'" id="rbtn_VesselCookUnnecessary8" #rbtn_VesselCookUnnecessary8
              [subid]="'rbtn_VesselCookUnnecessary8'"  [tabindex]="0"
              name="grp_VesselCookUnnecessary" value="08" [(ngModel)]="kymw0C00Model.vesselCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'マグカップ'" id="rbtn_VesselCookUnnecessary9" #rbtn_VesselCookUnnecessary9
              [subid]="'rbtn_VesselCookUnnecessary9'"  [tabindex]="0"
              name="grp_VesselCookUnnecessary" value="09" [(ngModel)]="kymw0C00Model.vesselCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'塗り物'" id="rbtn_VesselCookUnnecessary10" #rbtn_VesselCookUnnecessary10
              [subid]="'rbtn_VesselCookUnnecessary10'"  [tabindex]="0"
              name="grp_VesselCookUnnecessary" value="10" [(ngModel)]="kymw0C00Model.vesselCookUnnecessary">
            </app-radio-label>
          </div>
          <label class="list-input-title">イメージ</label>
          <div class="list-input-content">
            <app-radio-label [label]="'洋'" id="rbtn_PhotoImageCookUnnecessary1" #rbtn_PhotoImageCookUnnecessary1
              [subid]="'rbtn_PhotoImageCookUnnecessary1'"  [tabindex]="0"
              name="grp_PhotoImageCookUnnecessary" value="01" [(ngModel)]="kymw0C00Model.photoImageCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'和'" id="rbtn_PhotoImageCookUnnecessary2" #rbtn_PhotoImageCookUnnecessary2
              [subid]="'rbtn_PhotoImageCookUnnecessary2'"  [tabindex]="0"
              name="grp_PhotoImageCookUnnecessary" value="02" [(ngModel)]="kymw0C00Model.photoImageCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'おつまみ'" id="rbtn_PhotoImageCookUnnecessary3" #rbtn_PhotoImageCookUnnecessary3
              [subid]="'rbtn_PhotoImageCookUnnecessary3'"  [tabindex]="0"
              name="grp_PhotoImageCookUnnecessary" value="03" [(ngModel)]="kymw0C00Model.photoImageCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'温かみ'" id="rbtn_PhotoImageCookUnnecessary4" #rbtn_PhotoImageCookUnnecessary4
              [subid]="'rbtn_PhotoImageCookUnnecessary4'"  [tabindex]="0"
              name="grp_PhotoImageCookUnnecessary" value="04" [(ngModel)]="kymw0C00Model.photoImageCookUnnecessary">
            </app-radio-label>
            <app-radio-label [label]="'涼しさ'" id="rbtn_PhotoImageCookUnnecessary5" #rbtn_PhotoImageCookUnnecessary5
              [subid]="'rbtn_PhotoImageCookUnnecessary5'"  [tabindex]="0"
              name="grp_PhotoImageCookUnnecessary" value="05" [(ngModel)]="kymw0C00Model.photoImageCookUnnecessary">
            </app-radio-label>
          </div>
          <label class="list-input-title">断面</label>
          <div class="list-input-content">
            <app-checkbox-label id="chk_CrossSection2" #chk_CrossSection2 [subid]="'chk_CrossSection2'"
              [label]="'1個カットして中見せ'" [tabindex]="0" value="01" [(ngModel)]="kymw0C00Model.crossSection">
            </app-checkbox-label>
          </div>
          <label class="list-input-title">撮影演出</label>
          <div class="list-input-content">
            <app-checkbox-label id="chk_PhotoRenditionCookUnnecessary" #chk_RenditionCookUnnecessary 
            [subid]="'chk_RenditionCookUnnecessary'"
            [label]="'湯気出し'" [tabindex]="0" value="1" [(ngModel)]="kymw0C00Model.photoRenditionCookUnnecessary">
            </app-checkbox-label>
          </div>
          <div class="list-input-title layout_balance">
            <label>撮影指示内容</label>
            <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
              <fa-icon [icon]="iconQuestion"></fa-icon></label>
          </div>
          <div class="list-input-content">
            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_PhotoInstructContents4"
              #txta_PhotoInstructContents4 [subid]="'txta_PhotoInstructContents4'" [maxChars]="256" [tabindex]="0"
              [displayCountField]="true" [height]="92" [(ngModel)]="kymw0C00Model.photoInstructContents"
              [style.width.px]="980">
            </app-text-area>
          </div>
        </div>
      </div>
    </div>


    <!-- 画像種別：説明・素材 -->
    <div [style.display]="kymw0C00Model.imageTypeStatusVisible === 'D' ? 'block' : 'none'">
      <h3>撮影注意事項</h3>
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">切抜 or 角版</label>
          <div class="list-input-content">
            <app-radio-label [label]="'切り抜き（背景なし）'" id="rbtn_CropExistenceTypeD1" #rbtn_CropExistenceTypeD1 
              [subid]="'rbtn_CropExistenceTypeD1'" [tabindex]="0" [disabled]="!kymw0C00Model.cropExistenceTypeEnabled"
              name="grp_CropExistenceType1" value="1" [(ngModel)]="kymw0C00Model.cropExistenceType">
            </app-radio-label>
            <app-radio-label [label]="'角版（背景あり）'" id="rbtn_CropExistenceTypeD2" #rbtn_CropExistenceTypeD2
              [subid]="'rbtn_CropExistenceTypeD2'" [tabindex]="0" [disabled]="!kymw0C00Model.cropExistenceTypeEnabled"
              name="grp_CropExistenceType1" value="2" [(ngModel)]="kymw0C00Model.cropExistenceType">
            </app-radio-label>
          </div>
          <div class="list-input-title layout_balance">
            <label>撮影指示内容</label>
            <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
              <fa-icon [icon]="iconQuestion"></fa-icon></label>
          </div>
          <div class="list-input-content">
            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_PhotoInstructContents5"
              #txta_PhotoInstructContents5 [subid]="'txta_PhotoInstructContents5'" [maxChars]="256" [tabindex]="0"
              [displayCountField]="true" [height]="92" [(ngModel)]="kymw0C00Model.photoInstructContents"
              [style.width.px]="980">
            </app-text-area>
          </div>
        </div>
      </div>
    </div>


    <!-- 画像種別：その他 -->
    <div [style.display]="kymw0C00Model.imageTypeStatusVisible === 'E' ? 'block' : 'none'">
      <h3>撮影注意事項</h3>
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">切抜 or 角版</label>
          <div class="list-input-content">
            <app-radio-label [label]="'切り抜き（背景なし）'" id="rbtn_CropExistenceTypeE1" #rbtn_CropExistenceTypeE1 
              [subid]="'rbtn_CropExistenceTypeE1'" [tabindex]="0" [disabled]="!kymw0C00Model.cropExistenceTypeEnabled"
              name="grp_CropExistenceType2" value="1" [(ngModel)]="kymw0C00Model.cropExistenceType">
            </app-radio-label>
            <app-radio-label [label]="'角版（背景あり）'" id="rbtn_CropExistenceTypeE2" #rbtn_CropExistenceTypeE2
              [subid]="'rbtn_CropExistenceTypeE2'" [tabindex]="0" [disabled]="!kymw0C00Model.cropExistenceTypeEnabled"
              name="grp_CropExistenceType2" value="2" [(ngModel)]="kymw0C00Model.cropExistenceType">
            </app-radio-label>
          </div>
          <div class="list-input-title layout_balance">
            <label>撮影指示内容</label>
            <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
              <fa-icon [icon]="iconQuestion"></fa-icon></label>
          </div>
          <div class="list-input-content">
            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_PhotoInstructContents6"
              #txta_PhotoInstructContents6 [subid]="'txta_PhotoInstructContents6'" [maxChars]="256" [tabindex]="0"
              [displayCountField]="true" [height]="92" [(ngModel)]="kymw0C00Model.photoInstructContents"
              [style.width.px]="980">
            </app-text-area>
          </div>
        </div>
      </div>
    </div>


    <!-- 画像種別：裏面 -->
    <div [style.display]="kymw0C00Model.imageTypeStatusVisible === 'F' ? 'block' : 'none'">
      <h3>撮影注意事項</h3>
      <div class="block-row">
        <div class="column-list">
          <div class="list-input-title layout_balance">
            <label>撮影指示内容</label>
            <label aria-label="誌面：撮影指示書出力" data-microtip-position="top" role="tooltip" class="question">
              <fa-icon [icon]="iconQuestion"></fa-icon></label>
          </div>
          <div class="list-input-content">
            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_PhotoInstructContents7"
              #txta_PhotoInstructContents7 [subid]="'txta_PhotoInstructContents7'" [maxChars]="256" [tabindex]="0"
              [displayCountField]="true" [height]="92" [(ngModel)]="kymw0C00Model.photoInstructContents"
              [style.width.px]="980">
            </app-text-area>
          </div>
        </div>
      </div>
    </div>

    <div class="element-column">
      <div class="block-row">
        <button class="btn-secondary" id="btn_ReferenceImage"
          #btn_Display (click)="eventReferenceImage_CLICKHandler()"
          [tabindex]="0" multiple>参考資料アップロード</button>
        <ul #useImageGroups [style.white-space]="'nowrap'">
          <li *ngFor="let file of this.kymw0C00Model.referenceImageList; let i = index" id="referenceImage{{i}}" 
            (mousedown)="eventFileList_ITEMCLICK(i)">
            <div style="display: flex; flex-direction: column;">
              <div class="image-container">
                <img [src]="file.src" alt="">
              </div>
              <input type="text" class="image-list-item" [readonly]="true" plessInputTextSub 
                value="{{file.fileName}}" style="height: 29px;"> 
              <label class="image-label image-list-item">撮影指示内容</label>
              <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="" #txti_ReferenceImageContents
                [subid]="''" [maxChars]="256" [tabindex]="0" [displayCountField]="false" [height]="96"
                class="image-list-item" [(ngModel)]="file.photoInstructContents"
                [disabled]='!kymw0C00Model.referenceImagePhotoContentsDivEnabled'
                (change)="eventReferenceImageContents_CHANGEHandler()">
              </app-text-area>
            </div>
          </li>
        </ul>
      </div>
      <div class="layout_balance content-buttons">
        <button id="btn_NewImage" class="btn-tartiary" [tabindex]="0" [disabled]='!kymw0C00Model.btnNewImageEnabled'
          (click)="eventNewImage_CLICKkHandler()">画像個別項目をクリア</button>
        <button id="btn_Setting" class="btn-secondary" [tabindex]="0" [disabled]='!kymw0C00Model.btnSettingEnabled'
          (click)="eventSetting_CLICKHandler()">設定</button>
      </div>
    </div>
    <div>
      <h2>画像作成指示リスト</h2>
      <div class="grid-container">
        <wj-flex-grid #dtg_ImageInstructList [itemsSource]="kymw0C00Model.imageInstructList"
          id="dtg_ImageInstructList" [isReadOnly]="true" [deferResizing]="true" [allowSorting]="true"
          [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'" [tabindex]="0"
          (sortingColumn)="eventSortingColumn_Handler()" (sortedColumn)="eventSortedColumn_Handler()" forcedEnabledMode="true">
          <wj-flex-grid-column [minWidth]="5" [header]="'編集状態'" [width]="100" [binding]="'editStatus'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'画像ID'" [width]="160" [binding]="'imageID'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'画像種別'" [width]="200" [binding]="'imageTypeName'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'調理指示'" [width]="180" [binding]="'processInstructName'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'画像名'" [width]="303" [binding]="'imageName'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'画像ファイル名'" [width]="332" [binding]="'imageFileName'">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'ステータス'" [width]="dispDialog ? 200: 307" [binding]="'statusName'">
          </wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </div>
  </div>

  <footer class="footer-buttons" *ngIf="!dispDialog">
    <button id="btn_New" class="btn-tartiary" [disabled]='!kymw0C00Model.btnNewEnabled'
      (click)="eventNew_ClickHandler(null)" [tabindex]="0">全項目をクリア</button>
    <button id="btn_Output" class="btn-secondary" [disabled]='!kymw0C00Model.btnOutputEnabled'
      (click)="eventOutput_ClickHandler(null)" [tabindex]="0">出力</button>
    <button id="btn_Update" class="btn-primary" [disabled]='!kymw0C00Model.btnUpdateEnabled'
      (click)="eventUpdate_ClickHandler()" [tabindex]="0">更新</button>
  </footer>
</ng-template>